import React from 'react';
import { useAuth } from '../../../hooks/useAuth';
import { UserPermissions } from '../../../util';
import ViewWrapper from '../../elements/ViewWrapper';
import './DownloadsView.less';

const DownloadsView: React.FC = () => {
  const { hasPermission } = useAuth();

  if (!hasPermission(UserPermissions.DownloadsView)) {
    return (
      <ViewWrapper>
        <div className="downloads-iframe-container">
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <h3>Access Denied</h3>
            <p>You do not have permission to view the downloads page.</p>
          </div>
        </div>
      </ViewWrapper>
    );
  }

  return (
    <ViewWrapper>
      <div className="downloads-iframe-container">
        <iframe
          src="https://s3.us-east-2.amazonaws.com/readysetupdates/Updates3_0/downloads.html"
          title="ReadySet Downloads"
          className="downloads-iframe"
        />
      </div>
    </ViewWrapper>
  );
};

export default DownloadsView;
